var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "content-page", attrs: { id: "event-page" } },
    [
      _vm.item
        ? _c("event-page-header", {
            ref: "pageHeader",
            attrs: {
              item: _vm.item,
              "access-groups": _vm.accessGroups,
              "do-edit": _vm.doEdit,
              "create-mode": _vm.createMode,
            },
            on: {
              "update:item": function ($event) {
                _vm.item = $event
              },
            },
          })
        : _vm._e(),
      _vm.item
        ? _c(
            "div",
            { staticClass: "submenu navbar", attrs: { role: "navigation" } },
            [
              _c(
                "router-link",
                {
                  staticClass: "navbar-item",
                  class: _vm.createMode ? "disabled router-link-active" : "",
                  attrs: { to: { params: { section: "info" } } },
                },
                [_vm._v(_vm._s(_vm.$t("organization.info")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.item && _vm.section.match("info")
        ? _c("div", { staticClass: "contents is-12" }, [
            _c(
              "div",
              { staticClass: "event-info" },
              [
                _c("editable-html-section", {
                  ref: "BodyHtml",
                  staticClass: "presentation",
                  attrs: {
                    "do-edit": _vm.doEdit,
                    toolbar: false,
                    editors: _vm.item.Editors,
                  },
                  model: {
                    value: _vm.item.BodyHtml,
                    callback: function ($$v) {
                      _vm.$set(_vm.item, "BodyHtml", $$v)
                    },
                    expression: "item.BodyHtml",
                  },
                }),
                _vm.item.VideoPlaylist && !_vm.doEdit
                  ? _c(
                      "segment",
                      { attrs: { title: _vm.$t("videos.title") } },
                      [
                        _c("video-playlist-slides", {
                          attrs: {
                            options: _vm.videosSlickOptions,
                            items: _vm.item.VideoPlaylist,
                            width: 550,
                            height: 400,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.item.AudioPlaylist && !_vm.doEdit
                  ? _c(
                      "segment",
                      { attrs: { title: _vm.$t("audios.title") } },
                      [
                        _c("audio-playlist", {
                          attrs: { items: _vm.item.AudioPlaylist },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.section.match("visitor") && !_vm.createMode && _vm.item
        ? _c(
            "div",
            { staticClass: "contents" },
            [
              _c("entry-information-entry-description", {
                ref: "EntryDescription",
                attrs: {
                  "entry-description": _vm.entryDescription,
                  parent: _vm.item,
                  "show-opening-hours": true,
                  "show-ticket-prices": true,
                  "show-geo-location": true,
                  "do-edit": _vm.doEdit,
                  "can-remove": false,
                },
                on: {
                  "update:entryDescription": function ($event) {
                    _vm.entryDescription = $event
                  },
                  "update:entry-description": function ($event) {
                    _vm.entryDescription = $event
                  },
                  change: function ($event) {
                    _vm.entryDescription = $event
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.ready && _vm.doEdit && !_vm.createMode
        ? _c(
            "submit-button",
            { staticClass: "save", on: { click: _vm.onSave } },
            [_c("span", [_vm._v(_vm._s(_vm.$t("common.save")))])]
          )
        : _vm.ready && _vm.createMode
        ? _c(
            "submit-button",
            { staticClass: "save", on: { click: _vm.onPost } },
            [_c("span", [_vm._v(_vm._s(_vm.$t("articles.release")))])]
          )
        : _vm._e(),
      _vm.ready && _vm.item && _vm.item.SubjectItems
        ? _c("subject-items", {
            attrs: {
              "subject-items": _vm.item.SubjectItems,
              "show-actors": false,
              "show-artworks": true,
              "show-collections": true,
              "show-events": false,
              "show-organizations": true,
            },
          })
        : _vm._e(),
      _vm.childEvents && _vm.childEvents.length
        ? _c(
            "div",
            { staticClass: "child-events" },
            _vm._l(_vm.childEvents, function (item, index) {
              return _c("event-card", {
                key: index,
                attrs: { item: item, social: false },
              })
            }),
            1
          )
        : _vm._e(),
      _vm.parentEvent
        ? _c(
            "div",
            { staticClass: "parent-event" },
            [
              _c("event-brochure-stack", {
                attrs: { items: [_vm.parentEvent], count: 1 },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.ready && _vm.item && !_vm.doEdit
        ? _c(
            "segment",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasArtworks,
                  expression: "hasArtworks",
                },
              ],
              attrs: { title: _vm.$t("common.artworks") },
            },
            [
              _c(
                "div",
                { staticClass: "event-artworks" },
                [
                  _c("div", { staticClass: "query-options columns" }, [
                    _c(
                      "div",
                      { staticClass: "column is-left" },
                      [
                        _c("sort-option", {
                          staticClass: "by-actor",
                          attrs: {
                            label: _vm.$t("artworks.search.byActor"),
                            states: [false, "ArtistAsc", "ArtistDesc"],
                            icon: "icon-sort-alphabetical",
                          },
                          on: { toggle: _vm.setSortOperation },
                        }),
                        _c("sort-option", {
                          staticClass: "by-classification",
                          attrs: {
                            label: _vm.$t("artworks.search.byClassification"),
                            states: [
                              false,
                              "ClassificationAsc",
                              "ClassificationDesc",
                            ],
                            icon: "icon-sort-alphabetical",
                          },
                          on: { toggle: _vm.setSortOperation },
                        }),
                        _c("sort-option", {
                          staticClass: "by-production-time",
                          attrs: {
                            label: _vm.$t("artworks.search.byProductionDate"),
                            states: [
                              false,
                              "ProductionTimeLatestDesc,ProductionTimeEarliestDesc",
                              "ProductionTimeEarliestAsc,ProductionTimeLatestAsc",
                            ],
                            icon: "icon-sort-numeric",
                          },
                          on: { toggle: _vm.setSortOperation },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm.ready && !_vm.doEdit
                    ? _c("multi-stack", {
                        ref: "multiStack",
                        attrs: {
                          api: _vm.getArtworks,
                          infinite: false,
                          resolution: { x: 280 },
                          toolbar: true,
                        },
                        on: {
                          loaded: _vm.stackCallback,
                          error: function ($event) {
                            _vm.error = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      !_vm.createMode &&
      _vm.item &&
      _vm.item.CommunityPinnedPostId &&
      _vm.allowCommunity()
        ? _c("div", { staticClass: "somecontent adjusttocol" }, [
            _c("iframe", {
              directives: [
                {
                  name: "resize",
                  rawName: "v-resize",
                  value: { heightCalculationMethod: "taggedElement" },
                  expression: "{   heightCalculationMethod: 'taggedElement' }",
                },
              ],
              staticClass: "somecontent-if",
              attrs: {
                src:
                  _vm.getTribeCommunityUrl() +
                  "/embed/post/" +
                  _vm.item.CommunityPinnedPostId +
                  "?components=post,responses",
                frameborder: "0",
                allowtransparency: "true",
              },
            }),
          ])
        : !_vm.createMode &&
          _vm.item &&
          _vm.item.CommunityTopicId &&
          _vm.allowCommunity()
        ? _c("div", { staticClass: "somecontent" }, [
            _c("iframe", {
              directives: [
                {
                  name: "resize",
                  rawName: "v-resize",
                  value: { heightCalculationMethod: "taggedElement" },
                  expression: "{   heightCalculationMethod: 'taggedElement' }",
                },
              ],
              staticClass: "somecontent-if",
              attrs: {
                src:
                  _vm.getTribeCommunityUrl() +
                  "/embed/topic/" +
                  _vm.item.CommunityTopicId +
                  "?components=input,feed&feedLimit=5",
                frameborder: "0",
                allowtransparency: "true",
              },
            }),
          ])
        : !_vm.isAuthenticated() &&
          _vm.item &&
          (_vm.item.CommunityPinnedPostId || _vm.item.CommunityTopicId)
        ? _c(
            "div",
            { staticClass: "somecontent" },
            [
              _c("promotion-no-results-call-to-action", {
                staticClass: "is-parent",
                attrs: { "anonymous-only": true },
                scopedSlots: _vm._u([
                  {
                    key: "bubble-title",
                    fn: function () {
                      return [
                        _c("h3", { staticClass: "bubble-title" }, [
                          _vm._v(_vm._s(_vm.$t("social.loginToFindMore"))),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.ready && !_vm.error ? _c("loading-spinner") : _vm._e(),
      _vm.error
        ? _c("errors-message", { attrs: { error: _vm.error } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }